import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlLinzeDelete } from './connectionData.tsx'

const useLinzePublisher = () => {
  const [errorLinzeDelete, setErrorLinzeDelete] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  // Borra el aviso en Linze
  const linzeDelete = async (_id: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlLinzeDelete()
      await customPost(apiUrl, { _id: _id })

      setErrorLinzeDelete(null)

      return 'OK'
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorLinzeDelete(err)
      } else {
        setErrorLinzeDelete(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return {
    loading,
    linzeDelete,
    errorLinzeDelete,
  }
}

export default useLinzePublisher
